import React from 'react'
import Slider from 'react-slick'



function LogoSlider() {
    const settings = {
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: true,
        speed: 4000,
        autoplaySpeed: 0,
        cssEase: "linear",
        arrows: false,
        pauseOnHover: false,
        responsive: [
            {
                breakpoint: 1280, // large screen se chhota
                settings: {
                    slidesToShow: 5,
                },
            },
            {
                breakpoint: 1024, // tablet
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 768, // mobile landscape
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 480, // mobile portrait
                settings: {
                    slidesToShow: 2,
                },
            },
        ],
    };
    return (
        <>
            <Slider {...settings}>
                <div>
                    <div className="max-w-[95%] w-full rounded-[10px] py-[10px]">
                        <img src="/assets/logos/logo1.svg" className="h-[100px] mx-auto object-cover" alt="" />
                    </div>
                </div>
                <div>
                    <div className="max-w-[95%] w-full rounded-[10px] py-[10px]">
                        <img src="/assets/logos/logo2.svg" className="h-[100px] mx-auto object-cover" alt="" />
                    </div>
                </div>
                <div>
                    <div className="max-w-[95%] w-full rounded-[10px] py-[10px]">
                        <img src="/assets/logos/logo3.svg" className="h-[100px] mx-auto object-cover" alt="" />
                    </div>
                </div>
                <div>
                    <div className="max-w-[95%] w-full rounded-[10px] py-[10px]">
                        <img src="/assets/logos/logo4.svg" className="h-[100px] mx-auto object-cover" alt="" />
                    </div>
                </div>
                <div>
                    <div className="max-w-[95%] w-full rounded-[10px] py-[10px]">
                        <img src="/assets/logos/logo5.svg" className="h-[100px] mx-auto object-cover" alt="" />
                    </div>
                </div>
                <div>
                    <div className="max-w-[95%] w-full rounded-[10px] py-[10px]">
                        <img src="/assets/logos/logo6.svg" className="h-[100px] mx-auto object-cover" alt="" />
                    </div>
                </div>
                <div>
                    <div className="max-w-[95%] w-full rounded-[10px] py-[10px]">
                        <img src="/assets/logos/logo7.svg" className="h-[100px] mx-auto object-cover" alt="" />
                    </div>
                </div>
                {/* <div>
                    <div className="max-w-[95%] w-full rounded-[10px] py-[10px]">
                        <img src="/assets/logos/logo8.svg" className="h-[100px] mx-auto object-cover" alt="" />
                    </div>
                </div> */}
                <div>
                    <div className="max-w-[95%] w-full rounded-[10px] py-[10px]">
                        <img src="/assets/logos/logo9.svg" className="h-[100px] mx-auto object-cover" alt="" />
                    </div>
                </div>
                <div>
                    <div className="max-w-[95%] w-full rounded-[10px] py-[10px]">
                        <img src="/assets/logos/logo10.svg" className="h-[100px] mx-auto object-cover" alt="" />
                    </div>
                </div>
                <div>
                    <div className="max-w-[95%] w-full rounded-[10px] py-[10px]">
                        <img src="/assets/logos/logo11.svg" className="h-[100px] mx-auto object-cover" alt="" />
                    </div>
                </div>
            </Slider>
        </>
    )
}

export default LogoSlider
